import { CurrencyIcon } from '@root/entities/currency/ui/currency-icon'
import { PairIcon } from '@root/entities/pair/ui/common/pair-icon'

import type { WalletAssetModel } from '@root/entities/wallet/atoms'

type Props = {
  asset: WalletAssetModel
  size?: number
}

export const WalletAssetIcon: React.FC<Props> = ({ asset, size = 32 }) => {
  const { pair } = asset

  if (pair) {
    return <PairIcon size={size} pair={pair} />
  }
  return (
    <CurrencyIcon size={size} currency={asset.currency} outline="outline" />
  )
}
